
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
  "version": "0.0.1",
  "hash": "f60491144aed8f283f6f69f4c74c865f55574e4a"
};
/* tslint:enable */
  